var vst = vst || {};

vst.cfg = {
    systemFlag: "yth-sso",
    systemId: "59b639b234c042fb957a58e75f604de8",/*应用编目后由浙江数字人社工作台提供*/
    appKey: "07607b07bc664d1fa1a0c12e9699f2d0",/*应用编目后由浙江数字人社工作台提供*/
    appSecurityKey: "8d6c77b8b32e4e69a92a687c5bcceee7"/*应用编目后由浙江数字人社工作台提供*/
}